export default function (fn, keyParam = {}, resolveKey = 'success', rejectKey = 'fail', ...args) {
  return new Promise((resolve, reject) => {
    // alert('do success cb');
    if (resolveKey) {
      keyParam[resolveKey] = function resolvecb(...data) {
        // alert('promisify resolve', JSON.stringify(data));
        resolve(data);
      };
    }
    // alert('do fail cb');
    if (rejectKey) {
      keyParam[rejectKey] = function rejectcb(...data) {
        // alert('promisify reject', JSON.stringify(data));
        reject(data);
      };
    }
    // alert('do fn');
    fn(keyParam, args);
  });
}
